export type AppControlValueType = 'boolean' | 'number' | 'string' | 'json';

export interface IAppControl {
  id: string;
  key: string;
  label: string;
  description?: string | null;
  category: string;
  valueType: AppControlValueType | string;
  /** JSON-stringified value from backend. Use parseAppControlValue() to read. */
  value?: string | null;
  isPublic: boolean;
  created?: string;
  updated?: string;
}

export interface IAppControlList {
  count: number;
  rows: IAppControl[];
}

export const parseAppControlValue = <T = any>(
  control: IAppControl | null | undefined,
  fallback: T,
): T => {
  if (!control || control.value == null) return fallback;
  try {
    return JSON.parse(control.value) as T;
  } catch {
    return control.value as unknown as T;
  }
};

